import { FABRIC_CUSTOM_OBJECT, isEdgeOfPage, TEXTBOX } from '../../../utils';
import { isModifiableArrowLine } from '../../utils';
import { diagramObjectModified, pathArrowModified } from './handlePathArrow';
import {
  controlRectTextSVGModified,
  controlRectTextSVGMoving,
  controlRectTextSVGRemove,
  createControlRectTextSVG,
} from './handleRectTextSVG';
import {
  controlRectWithTextModified,
  controlRectWithTextRemove,
  createControlRectWithText,
} from './handleRectWithText';
import {
  controlScrollBarModified,
  controlScrollBarMoving,
  controlScrollBarRemove,
  createControlScrollBar,
} from './handleScrollBar';
import { controlRemove, controlSliderModified, controlSliderMoving, createControlSlider } from './handleSlider';

export function doubleClick(e) {
  const { target } = e;
  switch (target?.type) {
    case FABRIC_CUSTOM_OBJECT.slider:
      return createControlSlider(e);
    case FABRIC_CUSTOM_OBJECT.scrollBar:
      return createControlScrollBar(e);
    case FABRIC_CUSTOM_OBJECT.rectWithText:
      return createControlRectWithText(e);
    case FABRIC_CUSTOM_OBJECT.rectTextSVG:
      return createControlRectTextSVG(e);
  }
  return false;
}
export function objectMoving(e) {
  const { target } = e;
  if (target?.isNotObj) {
    switch (target?.name) {
      case FABRIC_CUSTOM_OBJECT.circleSlider:
        return controlSliderMoving(e);
      case FABRIC_CUSTOM_OBJECT.scrollBar:
        return controlScrollBarMoving(e);
      case FABRIC_CUSTOM_OBJECT.iconRectTextSVG:
        return controlRectTextSVGMoving(e);
    }
  }
  return false;
}
export function selectionClear(e) {
  const target = e?.deselected?.[0] || e?.target || e;
  if (target?.isNotObj) {
    switch (target?.name) {
      case FABRIC_CUSTOM_OBJECT.circleSlider:
        controlRemove(target);
        break;
      case FABRIC_CUSTOM_OBJECT.scrollBar:
        controlScrollBarRemove(target);
        break;
      case FABRIC_CUSTOM_OBJECT.textRectWithText:
        controlRectWithTextRemove(target);
        break;
      case FABRIC_CUSTOM_OBJECT.rectTextSVG:
        controlRectTextSVGRemove(target);
        break;
    }
  }
  return false;
}

export function editControl() {
  const target = window.canvas.getActiveObject();
  switch (target?.name) {
    case FABRIC_CUSTOM_OBJECT.circleSlider:
      return controlSliderModified(target);
    case FABRIC_CUSTOM_OBJECT.textRectWithText:
      if (target?.isNotObj) {
        return controlRectWithTextModified(target);
      }
      break;
    case FABRIC_CUSTOM_OBJECT.textRectTextSVG:
      if (target?.isNotObj) {
        return controlRectTextSVGModified(target);
      }
      break;
    case FABRIC_CUSTOM_OBJECT.triangleScrollBar:
      if (target?.isNotObj) {
        return controlScrollBarModified(target);
      }
      break;
    default:
      if (target?.type === FABRIC_CUSTOM_OBJECT.polyline) {
        if (target?.name === FABRIC_CUSTOM_OBJECT.pathArrow || target?.name === FABRIC_CUSTOM_OBJECT.line) {
          return pathArrowModified(target);
        }
      } else if (target?.isDiagram) {
        return diagramObjectModified(target);
      } else if (isModifiableArrowLine(target)) {
        pathArrowModified(target);
      }
  }

  return false;
}

export function customSetting() {
  let showAlignmentSetting = true;
  let showTransformComponent = true;
  const object = window.canvas.getActiveObject();
  if (isEdgeOfPage(object)) {
    showAlignmentSetting = false;
    showTransformComponent = false;
  }
  if (
    !object ||
    isModifiableArrowLine(object) ||
    object?.type === FABRIC_CUSTOM_OBJECT.polyline ||
    object?.isControlPoint
  )
    showTransformComponent = false;

  if (object?.type === TEXTBOX) showAlignmentSetting = false;

  return { showAlignmentSetting, showTransformComponent };
}
